import { withErrorBoundary } from '@sentry/react';
import React from 'react';
import { assets } from '../../assets';
import DefaultScreen from '../../components/containers/default-screen';
import MenuCard from '../../components/navigation/menu-card';
import { Fallback } from '../../components/utils/error-boundary';
import { Paths } from '../../navigation/paths';
import { useIntl } from 'react-intl';

const Settings = (): JSX.Element => {
  const intl = useIntl();
  return (
    <DefaultScreen
      background={assets.images.profile_bg}
      title={intl.formatMessage({ id: 'profilePage.settings.title' })}
      backUrl={Paths.profile}
    >
      <div className="grid gap-3 grid-cols-1 md:grid-cols-2">
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.settings.menu.loginData' })}
          description={intl.formatMessage({ id: 'profilePage.settings.menu.loginDataDescription' })}
          image={assets.images.settings_login}
          url={Paths.login_settings}
        />
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.settings.menu.contractModification' })}
          description={intl.formatMessage({
            id: 'profilePage.settings.menu.contractModificationDescription',
          })}
          image={assets.images.settings_contract}
          url={Paths.contact}
        />
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.settings.menu.notificationSettings' })}
          description={intl.formatMessage({
            id: 'profilePage.settings.menu.notificationSettingsDescription',
          })}
          image={assets.images.settings_notifications}
          url={Paths.contact}
        />
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.settings.menu.logoutSettings' })}
          description={intl.formatMessage({
            id: 'profilePage.settings.menu.logoutSettingsDescription',
          })}
          image={assets.images.settings_logout}
          url={Paths.logout_settings}
        />
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.settings.menu.localeSettings' })}
          description={intl.formatMessage({
            id: 'profilePage.settings.menu.localeSettingsDescription',
          })}
          image={assets.images.settings_language}
          url={Paths.locale_settings}
        />
      </div>
    </DefaultScreen>
  );
};

export default withErrorBoundary(Settings, { fallback: Fallback });
